"use strict";

var _interopRequireWildcard = require("@babel/runtime-corejs3/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.CollapsibleHeader = exports.CollapsibleHeaderBase = void 0;

var _objectSpread2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/objectSpread2"));

var _jsxRuntime = require("react/jsx-runtime");

var React = _interopRequireWildcard(require("react"));

var _react2 = require("@fluentui/react");

var _useTheme = require("../hooks/useTheme");

var _TitleBar = require("../TitleBar");

var _TitleBarAction = require("../TitleBar/TitleBarAction");

var _CollapsibleToggle = require("./CollapsibleToggle");

var getClassNames = (0, _react2.classNamesFunction)();

var CollapsibleHeaderBase = function CollapsibleHeaderBase(_ref) {
  var className = _ref.className,
      _ref$isExpanded = _ref.isExpanded,
      isExpanded = _ref$isExpanded === void 0 ? false : _ref$isExpanded,
      iconProps = _ref.iconProps,
      responsiveMode = _ref.responsiveMode,
      _ref$toggle = _ref.toggle,
      toggle = _ref$toggle === void 0 ? _CollapsibleToggle.CollapsibleToggle.caret : _ref$toggle,
      onClick = _ref.onClick,
      styles = _ref.styles,
      children = _ref.children,
      ariaLabel = _ref.ariaLabel;
  var theme = (0, _useTheme.useTheme)();

  var _getClassNames = getClassNames(styles, {
    theme: theme,
    isExpanded: isExpanded
  }),
      subComponentStyles = _getClassNames.subComponentStyles;

  var toggleProps = {
    onClick: onClick,
    ariaLabel: ariaLabel,
    ariaExpanded: isExpanded
  };
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_TitleBar.TitleBar, (0, _objectSpread2.default)((0, _objectSpread2.default)({
    className: (0, _react2.css)('ms-CollapsibleHeader', className),
    iconProps: iconProps,
    showBorder: !isExpanded,
    responsiveMode: responsiveMode,
    styles: subComponentStyles.titleBar
  }, toggle === _CollapsibleToggle.CollapsibleToggle.header ? toggleProps : {}), {}, {
    actions: /*#__PURE__*/(0, _jsxRuntime.jsx)(_TitleBarAction.TitleBarAction, (0, _objectSpread2.default)((0, _objectSpread2.default)({
      className: 'ms-CollapsibleHeader--caret',
      iconProps: {
        iconName: isExpanded ? 'ChevronUp' : 'ChevronDown',
        styles: subComponentStyles.caretIcon
      }
    }, toggle === _CollapsibleToggle.CollapsibleToggle.caret ? toggleProps : {}), {}, {
      styles: subComponentStyles.caret
    })),
    children: children
  }));
};

exports.CollapsibleHeaderBase = CollapsibleHeaderBase;
var CollapsibleHeader = (0, _react2.styled)(CollapsibleHeaderBase, function (_ref2) {
  var palette = _ref2.theme.palette,
      isExpanded = _ref2.isExpanded;
  return {
    subComponentStyles: {
      titleBar: !isExpanded ? {
        subcomponentStyles: {}
      } : {
        subComponentStyles: {
          control: {
            root: {
              backgroundColor: palette.neutralLighter
            }
          }
        }
      },
      caretIcon: {
        root: {
          color: palette.neutralSecondary
        }
      },
      caret: {}
    }
  };
});
exports.CollapsibleHeader = CollapsibleHeader;